<template>
  <div id="contenedor-listado-avances-expediente">
    <v-list flat>
      <v-list-group
        :value="false"
        v-for="tipo in getDocumentosSeparados"
        :key="tipo.tipo"
        class="base4 font-weight-bold primary--text h2 pa-3 my-2"
        :class="$vuetify.breakpoint.xs ? 'px-0 mx-0' : ''"
      >
        <template v-slot:activator>
          <v-list-item-title
            class="base4 font-weight-bold primary--text h2 px-0 mx-0"
          >
            {{ tipo.tipo }}
            <v-chip>{{ tipo.documentos.length }}</v-chip>
          </v-list-item-title>
        </template>
        <v-row class="bkground font-weight-bold primary--text h2 px-0 mx-0">
          <template v-for="documento in tipo.documentos">
            <template>
              <v-col
                cols="12"
                :class="$vuetify.breakpoint.xs ? 'px-0 mx-0' : ''"
                sm="6"
                md="6"
                lg="3"
                :key="`documento-${documento.id}`"
              >
                <v-card>
                  <object
                    :data="documento.rutaArchivo"
                    type="application/pdf"
                    height="400"
                    width="100%"
                  ></object>
                  <v-card-text class="pb-0">
                    {{ documento.referencia }} - {{ documento.observaciones }}
                  </v-card-text>
                  <v-card-actions class="pt-0">
                    <v-spacer></v-spacer>
                    <template v-if="!$vuetify.breakpoint.mobile">
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            icon
                            large
                            v-bind="attrs"
                            v-on="on"
                            @click="verDocumentoExpediente(documento)"
                          >
                            <v-icon>mdi-eye</v-icon>
                          </v-btn>
                        </template>
                        <span>Ver PDF</span>
                      </v-tooltip>
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            large
                            icon
                            v-bind="attrs"
                            v-on="on"
                            @click="mixDescargarArchivo(documento)"
                          >
                            <v-icon color="info">mdi-download</v-icon>
                          </v-btn>
                        </template>
                        <span>Descargar</span>
                      </v-tooltip>
                    </template>
                    <template v-else>
                      <v-btn
                        icon
                        large
                        @click="verDocumentoExpedienteMobile(documento)"
                      >
                        <v-icon>mdi-eye</v-icon>
                      </v-btn>
                      <v-btn
                        large
                        icon
                        @click="mixDescargarArchivo(documento)"
                      >
                        <v-icon color="info">mdi-download</v-icon>
                      </v-btn>
                    </template>
                  </v-card-actions>
                </v-card>
              </v-col>
            </template>
          </template>
        </v-row>
      </v-list-group>
    </v-list>
  </div>
</template>

<script>
import fileDownload from 'js-file-download';
import eventBus from '@/helpers/eventBus';

const BASE_URL = process.env.NODE_ENV !== 'production'
  ? 'http://localhost:3001'
  : 'https://sideop-file-server.daesaingenieria.com';

export default {
  name: 'ContratoListadoAvancesExpediente',
  props: {
    listadoDocumentosPresentacion: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      documentos: [],
    };
  },
  methods: {
    verDocumentoExpedienteMobile(documentoExpediente) {
      window.open(documentoExpediente.rutaArchivo);
    },
    verDocumentoExpediente(documentoExpediente) {
      eventBus.$emit('ver-documento-expediente', documentoExpediente);
    },
    setDocumentos() {
      this.listadoDocumentosPresentacion.forEach(async (documento) => {
        await this.mixGetPdf(documento);
      });
    },
    async mixDescargarArchivo(data) {
      this.mostrarDescargando = true;
      await this.axios
        .get(`${BASE_URL}/${data.publicKey}`, {
          responseType: 'blob',
        })
        .then((res) => {
          fileDownload(
            res.data,
            `${data.contrato.numero}_${data.documento.descripcion}_${data.referencia}.pdf`,
          );
        })
        .catch((err) => {
          this.mixMensajeError(err.data.message);
        });
      this.mostrarDescargando = false;

      this.progresoDescarga = null;
    },
    async mixGetPdf(data) {
      let rutaArchivo = null;
      if (data.publicKey) {
        await this.axios
          .get(`${BASE_URL}/${data.publicKey}`, {
            responseType: 'blob',
          })
          .then((res) => {
            rutaArchivo = URL.createObjectURL(
              new Blob([res.data], {
                type: 'application/pdf',
              }),
            );
            this.documentos.push({
              ...data,
              rutaArchivo,
            });
          })
          .catch((err) => {
            this.mixMensajeError(err.data.message);
          });
      }
    },
  },
  computed: {
    getTipos() {
      if (!this.documentos) return [];
      const tipos = [];
      this.documentos.forEach((documento) => {
        tipos.push(documento.documento.descripcion);
      });
      const tiposUnicos = tipos.filter(
        (item, index) => tipos.indexOf(item) === index,
      );
      return tiposUnicos;
    },
    getDocumentosSeparados() {
      if (!this.getTipos || this.documentos.length < 1) return [];
      const documentosSeparados = this.getTipos.slice().map((tipo) => ({
        tipo,
        documentos: this.documentos
          .filter((documento) => documento.documento.descripcion === tipo)
          .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)),
      }));
      return documentosSeparados;
    },
  },
  mounted() {
    this.setDocumentos();
  },
};
</script>

<style lang="scss">
</style>
